export default {
	//用于生成uuid
	S4() {
		return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
	},
	guid() {
		let str='-'
		return (this.S4() + this.S4() + str + this.S4() + str + this.S4() + str + this.S4()+ str +this.S4() + this.S4() + this.S4());
	}
}
